import { inject, Injectable } from '@angular/core'
import { User } from '@core/interfaces/user.interface'
import { CircuitsStore } from '@core/stores/circuits.store'
import { UsersStore } from '@core/stores/users.store'
import { LocalStorageService } from '@shared/services/local-storage.service'
import { firstValueFrom } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  sessionService = inject(SessionService)
  localStorage = inject(LocalStorageService)
  usersStore = inject(UsersStore)
  circuitStore = inject(CircuitsStore)

  async logout() {
    this.localStorage.removeItem('users')

    const response$ = this.sessionService.logout()
    const response = await firstValueFrom(response$)

    this.usersStore.setUser({} as User)
    this.circuitStore.setCircuits([])
    return response
  }

  async checkRequirements() {
    const response$ = this.sessionService.checkRequirements()
    const response = await firstValueFrom(response$)
    return response
  }
}
